import { createActionsStructure } from 'services/reduxHelpers'

/* ------------- Action Creators ------------- */

export const { authTypes, authActions } = createActionsStructure('auth', [
  { name: 'EMAIL_SIGN_IN', async: true },
  { name: 'SIGN_OUT', async: true },
])



// WEBPACK FOOTER //
// ./src/reduxModules/actions/AuthActions.js